module.exports = __webpack_public_path__ + "static/media/June_2026_5.e668f53d.webp";